import { createContext } from "react"

import type { SeminarValues } from "../api/seminarApi"
import type { SeminarEntryFormValues } from "../types/SeminarEntryFormValues"

export const SeminarEntryFormContext = createContext<{
  seminar: SeminarValues
  seminarEntryForm: SeminarEntryFormValues
  setSeminarEntryForm: React.Dispatch<React.SetStateAction<SeminarEntryFormValues>>
  isLoggedIn: boolean
}>(null as any)
